import { useVehicleStore } from '@/modules/vehicles/store/useVehicleStore';
import { VehicleDependencyServiceImpl } from '@/modules/vehicles/service/VehicleServiceImpl';
import { VehicleServiceExceptionDecorator } from '@/modules/vehicles/service/VehicleServiceExceptionDecorator';
import { VehicleServiceLogDecorator } from '@/modules/vehicles/service/VehicleServiceLogDecorator';
import { VehicleServiceHistoryDecorator } from '@/modules/vehicles/service/VehicleServiceHistoryDecorator';
import { IVehicleService } from '@/modules/vehicles/service/IVehicleService';

export class VehicleServiceFactory {
  private static instance: VehicleServiceFactory | null = null;

  private vehicleStore: typeof useVehicleStore;

  public static initialize(vehicleStore: typeof useVehicleStore): void {
    VehicleServiceFactory.instance = new VehicleServiceFactory(vehicleStore);
  }

  public static getInstance(): VehicleServiceFactory {
    if (VehicleServiceFactory.instance === null) {
      throw new Error(
        'VehicleServiceFactory not yet initialized. Call VehicleServiceFactory.initialize() first.',
      );
    }

    return VehicleServiceFactory.instance;
  }

  private constructor(vehicleStore: typeof useVehicleStore) {
    this.vehicleStore = vehicleStore;
  }

  public createVehicleService(): IVehicleService {
    let result: IVehicleService = this.makeVehicleService();

    result = new VehicleServiceExceptionDecorator(result);
    result = new VehicleServiceLogDecorator(result);
    result = new VehicleServiceHistoryDecorator(result);

    return result;
  }

  private makeVehicleService(): IVehicleService {
    return new VehicleDependencyServiceImpl(this.vehicleStore);
  }
}
